// Domain types for the Admin Business Units MSPA.

// The CountryPicker (react-bootstrap-country-select) yields either a country id
// string or an object; we accept both and extract the id when building payloads.
export type CountryValue = string | { id?: string; name?: string } | null;

// A row in the business units list table.
export interface BusinessUnit {
  id: string;
  name: string;
  externalName?: string;
  streetAddress?: string;
  street2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  active?: boolean;
}

// Controlled values for the business unit create/edit form.
export interface BusinessUnitFormValues {
  name: string;
  externalName: string;
  streetAddress: string;
  street2: string;
  city: string;
  state: string;
  postalCode: string;
  country: CountryValue;
}

export const emptyBusinessUnitForm: BusinessUnitFormValues = {
  name: "",
  externalName: "",
  streetAddress: "",
  street2: "",
  city: "",
  state: "",
  postalCode: "",
  country: "",
};
